import { Component, ElementRef, EventEmitter, Input, Output, viewChild } from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'shared-dp-toolbar-button',
  imports: [NgClass, TooltipModule, NgStyle],
  templateUrl: './toolbar-button.component.html',
})
export class ToolbarButtonComponent {
  @Input({ required: true }) iconPath!: string;
  @Input() additionalClasses = '';
  @Input() disabled = false;
  @Input() isActive = false;

  @Output() buttonClick = new EventEmitter<void>();

  readonly button = viewChild.required<ElementRef<HTMLButtonElement>>('button');
}
